import { createContext, useContext, useEffect } from 'react';

/**
 * Collapses the app sidebar for as long as a page asks, without touching the
 * reader's saved sidebar preference — the review's focus mode folds it to its
 * icon rail and hands it back unchanged. Provided by `PersistedSidebarProvider`.
 */
export const TransientSidebarCollapseContext = createContext<
  (collapsed: boolean) => void
>(() => undefined);

export function useTransientSidebarCollapse(collapsed: boolean): void {
  const setCollapsed = useContext(TransientSidebarCollapseContext);
  useEffect(() => {
    if (!collapsed) return;
    setCollapsed(true);
    return () => setCollapsed(false);
  }, [collapsed, setCollapsed]);
}
